import IBookmark from '../types/IBookmark';
import { adoptBookmarks } from '../utils/migration-util';

function loadBookmarks(): IBookmark[] {
  const bookmarks = localStorage.getItem('progressive-bookmarks_bookmarks');

  if (!bookmarks) {
    return [];
  }

  try {
    return adoptBookmarks(JSON.parse(bookmarks));
  } catch (err) {
    // Corrupted storage shouldn't crash the app on boot.
    console.error('Could not parse stored bookmarks:', err);
    return [];
  }
}

function saveBookmarks(bookmarks: IBookmark[]): void {
  localStorage.setItem(
    'progressive-bookmarks_bookmarks',
    JSON.stringify(bookmarks),
  );
}

export { loadBookmarks, saveBookmarks };
